export default __webpack_public_path__ + "static/media/employee-directory-img.93ff8494.png";